import { bl_fi_mst_entity_business_nature_hdr_RowClass } from '../../../dbschema/bl_fi_mst_entity_business_nature_hdr.model';
import {BaseContainerModel} from '../../base-container.model';


export class EntityBusinessNatureHdrContainerModel extends BaseContainerModel {
    bl_fi_mst_entity_business_nature_hdr: bl_fi_mst_entity_business_nature_hdr_RowClass = new bl_fi_mst_entity_business_nature_hdr_RowClass();
}